import { defineComponent, ref, openBlock, createElementBlock, Fragment, createVNode, unref, withCtx, createTextVNode, createElementVNode } from 'vue';
import _sfc_main$1 from '../../../component/dialog/dialog.vue.js';
import '@ssml-editor/core';
import { Button } from '@ssml-editor/vue';
import { ElButton, ElMessage } from 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                   */
/* empty css                                                     */
import '@ssml-editor/modules';
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                     */
import o from '../../../node_modules/.pnpm/@highlightjs_vue-plugin@2.1.0_highlight.js@11.11.1_vue@3.5.31_typescript@5.9.3_/node_modules/@highlightjs/vue-plugin/dist/highlightjs-vue.esm.min.js';
/* empty css                                                                                                                                               */
/* empty css                                                                                                                                                 */
import '../../../_virtual/common.js';
import { CodeUtils } from './code-utils.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "code-menu",
  props: {
    editor: {}
  },
  setup(__props) {
    const highlightjs = o.component;
    const dialogVisible = ref(false);
    const code = ref("");
    const codes = ref([]);
    function show() {
      dialogVisible.value = true;
    }
    function hide() {
      dialogVisible.value = false;
    }
    function formatCodes(codes2) {
      return codes2.map((code2) => {
        return CodeUtils.format(code2);
      }).join("\n");
    }
    async function copy(isFormat) {
      await navigator.clipboard.writeText(
        isFormat ? codes.value.join("") : code.value
      );
      hide();
      ElMessage.success({ message: "复制成功!", grouping: true });
    }
    function menuClickHandler() {
      if (__props.editor) {
        codes.value = __props.editor.serializeAndNormalize();
        code.value = formatCodes(codes.value);
        show();
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(Button), {
          "icon-class": "iconfont-ssml-editor icon-ssml-editor-code",
          onClick: menuClickHandler
        }, {
          default: withCtx(() => [
            createTextVNode("SSML")
          ]),
          _: 1
        }),
        createVNode(unref(_sfc_main$1), {
          title: "查看SSML",
          width: "80%",
          "align-center": true,
          "destroy-on-close": true,
          modelValue: dialogVisible.value,
          "onUpdate:modelValue": ($event) => dialogVisible.value = $event
        }, {
          header: withCtx(() => [
            createVNode(unref(ElButton), {
              type: "info",
              onClick: ($event) => copy(false)
            }, {
              default: withCtx(() => [
                createTextVNode("复制+关闭")
              ]),
              _: 1
            }, 8, ["onClick"]),
            createVNode(unref(ElButton), {
              type: "primary",
              onClick: ($event) => copy(true)
            }, {
              default: withCtx(() => [
                createTextVNode("压缩+复制+关闭(推荐)")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          footer: withCtx(() => [
            createVNode(unref(ElButton), {
              type: "info",
              onClick: ($event) => copy(false)
            }, {
              default: withCtx(() => [
                createTextVNode("复制+关闭")
              ]),
              _: 1
            }, 8, ["onClick"]),
            createVNode(unref(ElButton), {
              type: "primary",
              onClick: ($event) => copy(true)
            }, {
              default: withCtx(() => [
                createTextVNode("压缩+复制+关闭(推荐)")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          default: withCtx(() => [
            createElementVNode("div", { class: "se-code-wrapper" }, [
              createVNode(unref(highlightjs), {
                language: "xml",
                code: code.value
              }, null, 8, ["code"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "onUpdate:modelValue"])
      ], 64);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=code-menu.vue.js.map
